import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Injector } from '@angular/core';
import { Observable, of } from 'rxjs';
import { share, switchMap } from 'rxjs/operators';
import { FORM_PATH_TOKEN, FrameContext, FormExpressionsManifest, FormManifest, IFormExpressionManifestService, FORM_MANIFEST_SERVICE_TOKEN, IFormManifestService } from '@farris/devkit';
import { BasePathService } from '@farris/rtf';

@Injectable()
export class FormExpressionManifestService implements IFormExpressionManifestService {
  private static mainfests = new Map<string, Observable<any>>();
  constructor(
    private injector: Injector,
    private frameContext: FrameContext,
    private httpClient: HttpClient,
    @Inject(FORM_PATH_TOKEN) private modulePath,
    @Inject(FORM_MANIFEST_SERVICE_TOKEN) private formManifestService: IFormManifestService) { }

  public load(): Observable<any> {
    if (this.modulePath.endsWith('\/')) {
      this.modulePath = this.modulePath.substring(0, this.modulePath.length - 1);
    }

    return this.formManifestService.load().pipe(
      switchMap((formManifest: FormManifest) => {
        const expressions = formManifest.expressions;
        const expressionManifest = expressions.find((expressionManifest: FormExpressionsManifest) => expressionManifest.ns === this.frameContext.namespace);
        if (expressionManifest) {
          const expressionPath = BasePathService.convertPath(`${this.modulePath}/expressions/${expressionManifest.path}?version=${new Date().valueOf().toString()}`);
          const key = BasePathService.convertPath(`${this.modulePath}/expressions/${expressionManifest.path}`);
          const request$ = FormExpressionManifestService.mainfests.get(key);
          if (request$) {
            return request$;
          } else {
            const req$ = this.httpClient.get(expressionPath, { responseType: 'json' }).pipe(share());
            FormExpressionManifestService.mainfests.set(key, req$);
            return req$;
          }
        } else {
          return of({});
        }
      })
    );
  }
}
